__turbopack_context__.v({
  "additionalNotesContainer": "stepFields-module-scss-module__ScQPpa__additionalNotesContainer",
  "answer": "stepFields-module-scss-module__ScQPpa__answer",
  "answersContainer": "stepFields-module-scss-module__ScQPpa__answersContainer",
  "explanationIcon": "stepFields-module-scss-module__ScQPpa__explanationIcon",
  "explanationIconContainer": "stepFields-module-scss-module__ScQPpa__explanationIconContainer",
  "questionFieldHelper": "stepFields-module-scss-module__ScQPpa__questionFieldHelper",
  "questionFieldsWrp": "stepFields-module-scss-module__ScQPpa__questionFieldsWrp",
  "questionTitle": "stepFields-module-scss-module__ScQPpa__questionTitle",
  "recaptcha": "stepFields-module-scss-module__ScQPpa__recaptcha",
  "recaptchaWrapper": "stepFields-module-scss-module__ScQPpa__recaptchaWrapper",
  "textarea": "stepFields-module-scss-module__ScQPpa__textarea",
});
